import { render, staticRenderFns } from "./topNav.vue?vue&type=template&id=c545ae84"
import script from "./topNav.vue?vue&type=script&lang=js"
export * from "./topNav.vue?vue&type=script&lang=js"
import style0 from "./topNav.vue?vue&type=style&index=0&id=c545ae84&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports